import * as React from 'react';

import SearchInput from './SearchInput';

import './Header.css';

import { User } from 'firebase';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { cancelSearch } from '../actions';
import { ISearchRequest } from '../api';
import {
  doSearch,
  updateQuery,
} from '../thunks';
import { RootState } from '../types';
import { Gravatar } from './Gravatar';

interface IProps {
  autocompleteOptions: string[],
  currentUser: User | null,
  query: ISearchRequest,
  onCancelSearch: () => void,
  onChange: (query: string) => void,
  onSearch: () => void,
}

const Header: React.SFC<IProps> = ({
  autocompleteOptions,
  currentUser,
  onCancelSearch,
  onChange,
  onSearch,
  query,
}) => (
  <nav className="header">
    <ul>
      <li className="title">
        <Link to="/">Librarian</Link>
      </li>
      <li className="search">
        <SearchInput
                     value={ query ? query.query : '' }
                     onCancel={ onCancelSearch }
                     onChange={ onChange }
                     onSearch={ onSearch } />
        <ul
            className="autocompletes"
            style={ autocompleteOptions.length === 0 ? { display: 'none' } : {} }>
          { autocompleteOptions.map(x => (<li key={x}>{ x }</li>)) }
        </ul>
      </li>
      {
        process.env.REACT_APP_ENABLE_UPLOAD
        ? (<li className="link">
            <Link to="/upload">Upload</Link>
          </li>)
        : null
      }
      <li className="link">
        <Link to="/clips">Clips</Link>
      </li>
      <li className="gap" />
      <li className="profile-photo">
        {
          currentUser
          ? (<Link to="/profile">
              <Gravatar email={currentUser.email || ''} />
              <span className="username">{currentUser.email}</span>
            </Link>)
          : (<Link to="/login">Log In</Link>)
        }
      </li>
    </ul>
  </nav>
);

export const HeaderContainer = connect(
  ({auth, autocomplete, search}: RootState) => ({
    autocompleteOptions: autocomplete.options,
    currentUser: auth.currentUser,
    query: search.query,
  }),
  dispatch => ({
    onCancelSearch: () => { dispatch(cancelSearch()) },
    onChange: (query: string) => { dispatch<any>(updateQuery({query})) },
    onSearch: () => { dispatch<any>(doSearch()) },
  }),
)(Header)
export default HeaderContainer;



// WEBPACK FOOTER //
// ./src/components/Header.tsx